<template>
  <div class="myTeamList">
    <van-list
      class="nav_list"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
    >
      <van-cell
        center
        :title-class="id == item.id ? 'title' : ''"
        :title="item.title"
        v-for="(item, index) in list"
        :key="index"
        @click="seclectTeam(item.id)"
        class="item"
      >
        <template #right-icon>
          <van-icon
            v-if="id == item.id"
            name="checked"
            size=".40rem"
            color="#ff410a"
          />
        </template>
      </van-cell>
    </van-list>
    <!-- <div class="set_btn" @click="showPopup = true">创建团队</div> -->
    <van-popup v-model="showPopup" round style="width: 70%">
      <div class="pop">
        <div class="title">输入团队名称</div>
        <div class="textarea van-hairline--surround">
          <van-field
            v-model="teamName"
            type="textarea"
            maxlength="15"
            placeholder="请输入团队名称..."
            show-word-limit
          />
        </div>
        <div class="btn van-hairline--top">
          <div class="close van-hairline--right" @click="showPopup = false">
            取消
          </div>
          <div class="confirm" @click="setTeam">确定</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Cell, Icon, Popup, Field, Toast, List } from "vant";
import { getTeamList } from "@api/public";
export default {
  name: "MyTeamList",
  components: {
    [Cell.name]: Cell,
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [List.name]: List
  },
  data() {
    return {
      // showPopup: false, // 创建团队弹窗
      // teamName: "", // 创建团队名称
      id: "",
      list: "",
      loading: false,
      finished: false
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getTeamList();
  },
  methods: {
    /**
     * 获取团队列表
     */
    getTeamList() {
      getTeamList().then(res => {
        this.list = res.data;
        this.finished = true;
      });
    },
    /**
     * 选择团队
     */
    seclectTeam(id) {
      this.$router.replace({
        path: "/my/team",
        query: {
          id: id
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.myTeamList {
  min-height: 100vh;
  padding-bottom: 1.2rem;
  .title {
    font-size: 0.36rem;
    font-weight: bold;
    height: 0.6rem;
    line-height: 0.6rem;
  }
  .set_btn {
    background: #ff410a;
    color: #ffffff;
    position: fixed;
    bottom: 1rem;
    left: 50%;
    transform: translateX(-50%);
    line-height: 0.8rem;
    height: 0.8rem;
    border-radius: 0.4rem;
    padding: 0 1rem;
  }
  .pop {
    .title {
      text-align: center;
      font-size: 0.24rem;
      font-weight: bold;
      line-height: 0.8rem;
    }
    .textarea {
      margin: 0 0.3rem;
    }
    .btn {
      display: flex;
      justify-content: space-between;
      line-height: 0.8rem;
      text-align: center;
      margin-top: 0.36rem;
      div {
        flex: 1;
        font-size: 0.24rem;
      }
      .close {
        color: #000;
      }
      .confirm {
        color: #ff410a;
      }
    }
  }
  .van-popup--center.van-popup--round {
    border-radius: 0.1rem;
  }
  .van-field--min-height .van-field__control {
    min-height: 0;
  }
  [class*="van-hairline"]::after {
    border-color: #999999;
  }
}
</style>
